import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

export type GetLineItemValidatedByLogisticianParamsQuantity = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * A Line item can be split into different parts in the context of a return request.
 * This function returns the quantity of the line item that has been validated by the logistician.
 *
 * For example, the order contains 3 white t-shirt
 *
 * ***********************************
 * White t-shirt                   x3
 * ***********************************
 *
 * The customer returns 3 white t-shirt.
 * The logistician has validated 1 white t-shirt.
 * The merchant has validated 1 white t-shirt.
 * The merchant has rejected 1 white t-shirt.
 *
 * This function would return 1 (item validated by logistician)
 */
export function getLineItemValidatedByLogisticianQuantity({
  lineItem,
}: GetLineItemValidatedByLogisticianParamsQuantity) {
  return Math.max(
    0,
    lineItem.logistician_informations.reduce((acc, logisticianInformation) => {
      if (logisticianInformation.status === "ok") {
        return acc + logisticianInformation.quantity;
      }
      return acc;
    }, 0) -
      lineItem.merchant_informations.reduce(
        (acc, merchantInformation) => acc + merchantInformation.quantity,
        0,
      ),
  );
}
